
import { ref, watch } from "vue";
import {
  useCreators, usePage, useContentItems, useAuth, usePayments, useNotificationsMethods, useUsers
} from "@/modules";
import { AppPageConfig, AppPagePerspective } from "@/data/types";
import { useRoute } from "vue-router";
import { useCampaignContracts } from "@/modules/campaigns/campaign-contracts-module";
import { applyPureReactInVue } from 'veaury'
import NewCreatorAccount from "@/react_app/NewCreatorAccount/NewCreatorAccount";
import OldCreatorAccount from "@/pages/creators/account/OldCreatorAccount.vue";
import { isCreatorAccountEnabled } from '@/utils/globals/feature-flags';
import { useSocketIo, useSocketMethods } from "@/services/socket";
import { openSocialPopup} from "@/utils/globals/popup-utils";
import { SocialConnectResponse } from "@/pages/auth/social-def";
import router from "@/router";

export default {
  components: {
    NewCreatorAccount: applyPureReactInVue(NewCreatorAccount),
    OldCreatorAccount
  },
  props: {
    viewPerspective: String,
  },
  setup(props: any, ctx: any) {
    const { config } = usePage<AppPageConfig>({
      title: "account creator",
      ...props,
    });
    const tabview = ref(0);
    const gigapayModule = usePayments();
    const route = useRoute();
    const content = useContentItems();
    const creatorsController = useCreators(config.value.viewPerspective);
    const { manager: { getUserAppliedCampaigns } } = useUsers();
    const applications = ref();
    const { user } = useAuth();
    const contracts = ref();
    const closeModalRef = ref(false);
    const contractManager = useCampaignContracts(config.value.viewPerspective as AppPagePerspective);

    const gigapayUser = ref();
    gigapayModule.checkVerified().then((data) => {
      gigapayUser.value = data;
    });

    if (user.value && user.value?.type === "creator") {
      contractManager.loadContracts().then((contractsArray) => {
        contractsArray?.forEach((campaign: any) => {
          campaign.contracts = campaign.contracts.filter((contract: any) => contract.creator);
        });
        contracts.value = contractsArray;
      });
    }

    if (user.value && user.value?.type === "agencyOwner") {
      setTimeout(() => {
        contractManager.loadContracts().then((contractsArrayX) => {
          contractsArrayX?.forEach((campaign: any) => {
            campaign.contracts = campaign.contracts.filter((contract: any) => contract.channel);
          });
          contracts.value = contractsArrayX;
        });
      }, 111);
    }

    const loadAppliedCampaigns = () => getUserAppliedCampaigns(route.params.creatorID as string);

    creatorsController.manager.load(route.params.creatorID as string);
    loadAppliedCampaigns().then((data) => {
      applications.value = data;
    });

    content.list.loadMyLatest(user.value?.id as string, 6);
    const showPayment = ref(false);

    const paymentInfoChange = async (payload: any) => {
      if (user.value) {
        await gigapayModule.updatePaymentData(user.value?.id, payload);
      }

      showPayment.value = false;
      await creatorsController.manager.load(route.params.creatorID as string);

      gigapayModule.checkVerified().then((data) => {
        gigapayUser.value = data;
      });
    };

    const closeModal = () => {
      closeModalRef.value = true;
    };

    const alredyInvited = ref(false);
    const sendAgain = async () => {
      const resended = await gigapayModule.resendInvitation();
      alredyInvited.value = resended;
    };

    const notificationsForUser = ref<any[]>([]);
    const userId = ref();
    const notificationsMethods = useNotificationsMethods();

    if (user.value) {
      userId.value = user.value?.id;
    }

    const socket = useSocketIo(userId.value as string);
    const socketMethods = useSocketMethods(socket);

    const getMoreNotifications = async (firstLoad = false) => {
      if (!firstLoad) {
        // skip.value += 5;
        // limit.value += 5;
      }
      socketMethods.getNotificationsUser(userId.value as string, 5, 0);
      socket.on('notifications-data', (data: any) => {
        notificationsForUser.value = data.filter((el: any) => el.type === 'invite');
      });
    };
    getMoreNotifications();

    const loadChannels = async () => creatorsController.youtube.getCreatorChannels(userId.value, creatorsController.manager.creator.value?.type);

    const successAddChannel = async () => {
      await loadChannels();
    };

    watch(creatorsController.manager.creator, () => {
      if (creatorsController.manager.creator.value?.name) {
        config.value.title = creatorsController.manager.creator.value?.name;
        loadChannels();
      }
    });

    const mangopayObject = ref(user?.value?.mangopay);
    const currentPaymentInfo = mangopayObject.value;

    const submitNaturalUserData = (payload: any) => {
      ctx.emit('changeInfo', payload);
    };

    const submitLegalUserData = (payload: any) => {
      ctx.emit('changeInfoLegal', payload);
    };

    const openConnectPopup = (): void => {
      openSocialPopup(
        'youtube',
        { type: userId.value, action: 'add_channel_yt' },
        async (err?: Error | null, response?: SocialConnectResponse) => {
          console.log(err);
          if (response) {
            ctx.emit('success-add-channel');
          }
        },
      );
    };

    const handleContentRouting = (id: string) => {
      router.push({ name: 'content-item', params: { itemID: id } });
    }
    return {
      paymentInfoChange,
      closeModal,
      sendAgain,
      alredyInvited,
      closeModalRef,
      config,
      creator: creatorsController.manager.creator,
      channels: creatorsController.youtube.getCreatorChannelsResult,
      user,
      contracts,
      applications,
      tabview,
      latestContent: content.list.loadMyLatestResult,
      showPayment,
      gigapayUser,
      isCreatorAccountEnabled,
      notificationsForUser,
      notificationsMethods,
      openConnectPopup,
      submitNaturalUserData,
      submitLegalUserData,
      currentPaymentInfo,
      handleContentRouting
    };
  },
};
